const SESSION_ID_KEY = 'sparkapp_session_id';
const SESSION_LAST_ACTIVITY_KEY = 'sparkapp_session_last_activity';
const SESSION_TIMEOUT_MS = 30 * 60 * 1000;

export interface DeviceMetadata {
  device_type: 'mobile' | 'desktop' | 'tablet';
  browser: string;
  os: string;
  language: string;
  screen_size: string;
}

export function getOrCreateSessionId(): string {
  const lastActivity = sessionStorage.getItem(SESSION_LAST_ACTIVITY_KEY);
  const existingId = sessionStorage.getItem(SESSION_ID_KEY);

  if (existingId && lastActivity) {
    const elapsed = Date.now() - parseInt(lastActivity, 10);
    if (elapsed < SESSION_TIMEOUT_MS) {
      sessionStorage.setItem(SESSION_LAST_ACTIVITY_KEY, String(Date.now()));
      return existingId;
    }
  }

  const newId = crypto.randomUUID();
  sessionStorage.setItem(SESSION_ID_KEY, newId);
  sessionStorage.setItem(SESSION_LAST_ACTIVITY_KEY, String(Date.now()));
  return newId;
}

export function touchSession(): void {
  sessionStorage.setItem(SESSION_LAST_ACTIVITY_KEY, String(Date.now()));
}

export function getDeviceMetadata(): DeviceMetadata {
  const ua = navigator.userAgent;
  const width = window.innerWidth;

  let device_type: 'mobile' | 'desktop' | 'tablet' = 'desktop';
  if (width <= 768) device_type = 'mobile';
  else if (width <= 1024) device_type = 'tablet';

  let browser = 'unknown';
  if (ua.includes('Firefox')) browser = 'Firefox';
  else if (ua.includes('Edg')) browser = 'Edge';
  else if (ua.includes('Chrome')) browser = 'Chrome';
  else if (ua.includes('Safari')) browser = 'Safari';

  let os = 'unknown';
  if (ua.includes('Windows')) os = 'Windows';
  else if (ua.includes('Mac')) os = 'macOS';
  else if (ua.includes('Linux')) os = 'Linux';
  else if (ua.includes('Android')) os = 'Android';
  else if (ua.includes('iPhone') || ua.includes('iPad')) os = 'iOS';

  return {
    device_type,
    browser,
    os,
    language: navigator.language,
    screen_size: `${window.innerWidth}x${window.innerHeight}`,
  };
}
